import {defineStore} from "pinia";

export const useAuthenticationStore = defineStore('authentication', {
    state: () => ({
        csrfToken: "",
        authenticated: false
    }),
    getters: {},
    actions: {
        async getCSRFToken() {
            try {
                const response = await this.axios.get("/csrf/", {withCredentials: true});
                this.csrfToken = response.headers["x-csrftoken"];
            } catch (e) {
                console.log(e);
            }
        },
    }
});
